module.exports = __webpack_public_path__ + "img/plug-white.32fe687c.svg";